import {PlantHierarchyType} from '@hproduce/suite-core'

export enum MenuNodeType {
  Feature = 'Feature',
  Folder = 'Folder'
}

type FeatureBase = {
  id: number
  name: string
  displayOrder: number
}

export interface FeatureCatalogItem {
  id: number
  name: string
  owner: string
  scope: PlantHierarchyType[]
}

export type FeatureEntry = FeatureBase & {
  type: MenuNodeType.Feature
  featureId: number
  scope: PlantHierarchyType[]
  isHomePage?: boolean
}

export type FolderEntry = FeatureBase & {
  type: MenuNodeType.Folder
  children: FeaturesMenu
}

export type FeatureMenuEntry = FeatureEntry | FolderEntry

export type FeaturesMenu = FeatureMenuEntry[]

export interface UpdateMenuInputModel {
  displayOrder: number
  type: 'Unknown' | 'Feature' | 'Folder'
  name: string | null
  children: UpdateMenuInputModel[] | null
  featureId: number | null
  isHomePage: boolean | null
}
